import Card from '../components/Card'; // Güncellediğimiz motion'lı Card
import announcements from '../data/announcements';
import { motion } from 'framer-motion';

export default function Announcements() {
  const formatDate = (dateString) => {
    // ... (Tarih fonksiyonu aynı kalsın)
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const getCategoryColor = (category) => {
     // ... (Renk fonksiyonu aynı kalsın)
     switch(category) {
       case 'Ders': return 'bg-blue-50 border-blue-200 text-blue-700';
       case 'Etkinlik': return 'bg-emerald-50 border-emerald-200 text-emerald-700';
       case 'Araştırma': return 'bg-purple-50 border-purple-200 text-purple-700';
       default: return 'bg-gray-50 border-gray-200 text-gray-700';
     }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-5xl md:text-6xl font-serif font-bold text-navy mb-4 tracking-tight"
          >
            Duyurular
          </motion.h1>
          <motion.div 
            initial={{ width: 0 }}
            animate={{ width: 96 }} // 24 rem = w-24
            transition={{ duration: 1, delay: 0.5 }}
            className="h-1 bg-gradient-to-r from-transparent via-navy to-transparent mx-auto mb-4"
          ></motion.div>
        </div>

        <div className="space-y-6">
          {announcements.map((announcement, index) => (
            // Card bileşenine delay prop'u göndererek hafif kademeli giriş yapıyoruz
            <Card key={announcement.id} delay={index * 0.1} className="rounded-xl border-2 border-gray-200 p-8">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-2xl font-serif font-bold text-navy flex-1">
                  {announcement.title}
                </h3>
                <span className={`px-4 py-1.5 rounded-lg text-xs font-semibold border ${getCategoryColor(announcement.category)}`}>
                  {announcement.category}
                </span>
              </div>
              
              <p className="text-gray-500 text-sm mb-4 font-medium">
                📅 {formatDate(announcement.date)}
              </p>
              
              <p className="text-gray-700 leading-relaxed text-lg">
                {announcement.content}
              </p>
            </Card>
          ))}
        </div>

        {announcements.length === 0 && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }}
            className="bg-white rounded-xl border-2 border-gray-200 p-12"
          >
            <p className="text-gray-500 text-center text-lg">
              Henüz duyuru bulunmamaktadır.
            </p>
          </motion.div>
        )}
      </div>
    </div>
  );
}